import type { SVGProps } from 'react'
const SvgPicpay = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#picpay_svg__a)">
      <path d="M16.264 1.912h-1.906V3.83h1.906zm-10.69.933H2.843V5.25H5.38c1.61 0 2.538.785 2.538 2.259S6.99 9.817 5.38 9.817H2.842V5.302H.014v10.554h2.828v-3.633h2.684c3.27 0 5.174-1.768 5.174-4.812 0-2.848-1.855-4.566-5.125-4.566M18.169 0h-5.711v5.742h5.71zm-.928 4.762h-3.807V.93h3.807z" />
    </g>
    <defs>
      <clipPath id="picpay_svg__a">
        <path d="M0 0h18v18H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgPicpay
